import moment from 'moment'

export const FormatterISODateTime = {

  toDate: (date = new Date()) => moment(date).utc().format('YYYY-MM-DD'),

  toTime: (time = new Date()) => moment(time).utc().format('HH:mm:ss'),

  toDateTime: (datetime = new Date()) => moment(datetime).format('YYYY-MM-DD HH:mm:ss')

}

export const FormatterDateTime = {

  toDate: (date = new Date()) => moment(date).format('YYYY-MM-DD'),

  toTime: (time = new Date()) => moment(time).format('HH:mm:ss'),

  toDateTime: (datetime = new Date()) => moment(datetime).format('YYYY-MM-DD HH:mm:ss')

}

export const Format = (date = new Date()) => {
  return {
    to: format => {
      if(moment(date).isValid())
        return moment(date).format(format)

      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/filters/DateFormatter.js